import script from "./VehicleRegistrationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleRegistrationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleRegistrationInfo.vue?vue&type=style&index=0&id=1f2b2ab1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2b2ab1"]])

export default __exports__